import React from 'react';
import {
  FaChevronLeft,
  FaChevronRight,
  FaCheck,
  FaTimesCircle,
} from 'react-icons/fa';

import { useLocalTranslation } from '../../../common/hooks/useLocalTranslation';

interface PublicSurveyNavigationProps {
  onBack: () => void;
  onNext: () => void;
  onFinishBlocked: () => void;
  canGoBack: boolean;
  isLastQuestion: boolean;
  isBlocked?: boolean;
  isLoading?: boolean;
  currentLanguage?: string;
}

export const PublicSurveyNavigation: React.FC<PublicSurveyNavigationProps> = ({
  onBack,
  onNext,
  onFinishBlocked,
  canGoBack,
  isLastQuestion,
  isBlocked = false,
  isLoading,
  currentLanguage,
}) => {
  const { t, tk } = useLocalTranslation('administrationLng', currentLanguage);
  return (
    <div className="public-survey-navigation">
      <button
        type="button"
        onClick={onBack}
        disabled={!canGoBack}
        className="public-survey-btn-back"
      >
        <FaChevronLeft size={20} />
        <span>{t(tk.publicSurvey.back)}</span>
      </button>

      {isBlocked ? (
        <button
          type="button"
          onClick={onFinishBlocked}
          disabled={isLoading}
          className="public-survey-btn-finish-blocked"
        >
          <span>{t(tk.publicSurvey.finishSurvey)}</span>
          <FaTimesCircle size={20} />
        </button>
      ) : (
        <button
          type="button"
          onClick={onNext}
          disabled={isLoading}
          className={`public-survey-btn-next ${isLastQuestion ? 'gradient' : ''}`}
        >
          <span>
            {isLastQuestion
              ? t(tk.publicSurvey.finish)
              : t(tk.publicSurvey.next)}
          </span>
          {isLastQuestion ? (
            <FaCheck size={20} />
          ) : (
            <FaChevronRight size={20} />
          )}
        </button>
      )}
    </div>
  );
};
